import type { GlobalState } from '../index';
import type { IState } from '../reducers/metadata';

export const getMetadata =
  (pathname: string) =>
  (state: GlobalState): IState['data'][string] =>
    state.metadata.data[pathname];
